export default __webpack_public_path__ + "static/post-illustration-971c33f9f468e6ba4a35655e460e5bb5.png";